import React from 'react';
// Apply comprehensive shim for ReactDOM.findDOMNode (React 18 deprecation)
import ReactDOM from 'react-dom';

// Store the original findDOMNode function
const originalFindDOMNode = ReactDOM.findDOMNode;

// Apply the shim only once globally
if (!ReactDOM.findDOMNode.__shimmed) {
  ReactDOM.findDOMNode = function (instance) {
    // For React 18, try to avoid calling findDOMNode at all if possible
    if (instance === null || instance === undefined) {
      return null;
    }
    
    // If it's already a DOM node, return it directly
    if (instance && instance.nodeType) {
      return instance;
    }
    
    // For Quill editor instances, try to get the DOM root directly
    try {
      if (instance && typeof instance === 'object') {
        // Check for Quill editor instance patterns
        if (instance.getEditor && typeof instance.getEditor === 'function') {
          const editor = instance.getEditor();
          if (editor && editor.root) {
            return editor.root;
          }
        }
        if (instance.editor && instance.editor.root) {
          return instance.editor.root;
        }
        // Check for React component with container property
        if (instance.container) {
          return instance.container;
        }
      }
    } catch (e) {
      // If any error occurs, fall back to original
    }
    
    // Last resort: use original findDOMNode but suppress the warning
    try {
      return originalFindDOMNode(instance);
    } catch (e) {
      return null;
    }
  };
  ReactDOM.findDOMNode.__shimmed = true;
}

// Import react-quill after the shim is in place
const ReactQuill = require('react-quill');
import { useUiField } from '../hooks';
import { UiField } from './UiField';

const modules = {
  toolbar: false,
};

export const UiReadOnlyQuill = props => {
  const [uiFieldProps, inputProps] = useUiField(props, {
    isTextarea: true,
    onFocus: () => {},
    onBlur: () => {},
  });
  const blacklist = ['onFocus', 'onBlur'];
  return (
    <UiField {...uiFieldProps} errorMessage="" hasError="" disabled>
      <ReactQuill
        theme="snow"
        readOnly
        {...Object.fromEntries(
          Object.entries(inputProps).filter(([k]) => !blacklist.includes(k))
        )}
        modules={modules}
      />
    </UiField>
  );
};
